import { useState } from "react";
import useLanguage from "../../../../utils/useLanguage";

export default function DefaultQga() {
  const { t } = useLanguage();
  const [isImgLoad, setImgLoad] = useState(false);

  return (
    <div className="w-screen h-screen relative flex items-start justify-center">
      <img
        src="/images/qga/funnel-default-phone-mockup-2.webp"
        alt="default"
        className={isImgLoad ? "block" : "hidden"}
        onLoad={() => setImgLoad(true)}
      />

      <span
        className={`absolute top-[67%] w-full right-0 text-center font-extrabold px-4 pt-1 leading-[1.25] text-[clamp(24px,1.8vw,28px)] ${ isImgLoad ? "block" : "hidden"} step-def-text`}>
        <span className="block p-4 bg-[#8364ff] text-white rounded-[6px]">
          {t("global.step1_default")}
        </span>
      </span>
    </div>
  );
}
